var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C18.6281 0 24 5.37188 24 12C24 18.6281 18.6281 24 12 24C8.07187 24 4.58766 22.1156 2.39953 19.2C2.15062 18.8672 2.21766 18.3984 2.54859 18.15C2.88 17.9016 3.35016 17.9672 3.59906 18.3C5.51719 20.85 8.56406 22.5 12 22.5C17.7984 22.5 22.5 17.7984 22.5 12C22.5 6.20156 17.7984 1.5 12 1.5C7.81406 1.5 4.19578 3.95156 2.51016 7.5H6.75C7.1625 7.5 7.5 7.8375 7.5 8.25C7.5 8.6625 7.1625 9 6.75 9H0.75C0.335812 9 0 8.6625 0 8.25V2.25C0 1.83562 0.335812 1.5 0.75 1.5C1.16438 1.5 1.5 1.83562 1.5 2.25V6.14531C3.54656 2.49797 7.48125 0 12 0ZM12 6C12.4125 6 12.75 6.3375 12.75 6.75V11.6906L16.2797 15.2203C16.575 15.5109 16.575 15.9891 16.2797 16.2797C15.9891 16.575 15.5109 16.575 15.2203 16.2797L11.4703 12.5297C11.3297 12.3891 11.2078 12.1969 11.2078 12V6.75C11.2078 6.3375 11.5875 6 11.9578 6H12Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.09066090017219b9b0ce87186d8b0e27.svg";
export { ForwardRef as ReactComponent };